import { FC } from "react";
import { LeftRailNavigationFlatProps } from "./LeftRailNavigationFlat";
import cn from "classnames";
import { getDataLinkAttributes } from "@/helpers";
import Link from "@/components/Link";

const LeftRailNavigationFlatDesktop: FC<
  Omit<LeftRailNavigationFlatProps, "children"> & {
    activeItemIndex: number;
  }
> = ({ navItems, activeItemIndex }) => {
  return (
    <ul className="relative flex flex-col items-start gap-y-4 self-start after:absolute after:top-3 after:bottom-[10px] after:left-[-42px] after:w-[21.8px] after:border-[3px] after:border-r-0 after:border-dotted after:border-[var(--color-symbol-cool-gray-600-graphic)]">
      {navItems.map((item, index) => (
        <li
          className="relative focus:outline-0 data-[focus]:outline-1"
          key={`${item.name}-${index}`}
        >
          <Link
            href={item.href}
            className={cn(
              "text-subhead-2xs text-tab-link active:text-tab-link-pressed hover:text-tab-link-hover inline-block cursor-pointer text-left font-bold decoration-2 hover:underline active:underline",
              activeItemIndex === index &&
                "before:absolute before:top-[calc(50%-5px)] before:left-[-26px] before:z-20 before:size-3 before:rounded-full before:bg-[var(--color-symbol-orange-400-graphic)] after:absolute after:top-[calc(50%-1px)] after:left-[-95px] after:z-20 after:h-[3px] after:w-[80px] after:animate-[vertical-tab-growing_0.4s_ease-in_1] after:rounded-lg after:bg-[var(--color-symbol-orange-400-graphic)] after:transition-all",
            )}
            {...getDataLinkAttributes({ dlt: item.dlt, dld: item.dld })}
          >
            {item.name}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default LeftRailNavigationFlatDesktop;
